import {
  dependencyReportSchema,
  packageSummarySchema,
  projectHealthSchema,
  versionDetailSchema,
} from '@repo/shared';
import type { DependencyReport, PackageSummary, ProjectHealth, VersionDetail } from '@repo/shared';
import { apiRequest } from '../../lib/api';

/**
 * Typed client calls for the packages API.
 * Every path segment is encodeURIComponent-encoded so that npm scopes
 * (@scope/name), Go module paths, and Maven group:artifact identifiers are
 * all round-tripped correctly through the Worker router.
 */

export function getPackage(system: string, name: string): Promise<PackageSummary> {
  const path = `/v1/packages/${encodeURIComponent(system)}/${encodeURIComponent(name)}`;
  return apiRequest(path, packageSummarySchema);
}

export function getVersion(system: string, name: string, version: string): Promise<VersionDetail> {
  const path = `/v1/packages/${encodeURIComponent(system)}/${encodeURIComponent(name)}/versions/${encodeURIComponent(version)}`;
  return apiRequest(path, versionDetailSchema);
}

export function getDependencies(
  system: string,
  name: string,
  version: string,
): Promise<DependencyReport> {
  const path = `/v1/packages/${encodeURIComponent(system)}/${encodeURIComponent(name)}/versions/${encodeURIComponent(version)}/dependencies`;
  return apiRequest(path, dependencyReportSchema);
}

export function getProjectHealth(id: string): Promise<ProjectHealth> {
  const path = `/v1/projects/${encodeURIComponent(id)}`;
  return apiRequest(path, projectHealthSchema);
}
